import { Component } from '@angular/core';

@Component({
  selector: 'no-email-received',
  template: `
	  <h2 translate>APP.ACCESS.NO_EMAIL_TITLE</h2>
	  <p>
		  <span translate>APP.ACCESS.NO_EMAIL_CHECK_SPAM_FOLDER</span><br>
		  <span class="bold">noreply@acslworld.com</span>.<br>
		  <span translate>APP.ACCESS.NO_EMAIL_CONTACT_SUPPORT</span>:<br>
		  <a href="mailto:support@acswlworld.com">support@acslworld.com</a>
	  </p>
	`
})
export class NoEmailReceivedComponent {
}